import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { problems } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-stage bg-grid py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-220" data-mp="30h7kvn5mjqti">
      <div className="mx-auto max-w-4xl px-4" data-id="element-221" data-mp="30j0v1cfg4t69">
        <div className="text-center" data-id="element-222" data-mp="2vpg424c9szgk">
          <p className="font-mono text-[11px] font-bold uppercase tracking-[.2em] text-gold" data-id="element-223" data-mp="2voefqy68uggw">La realidad profesional</p>
          <h2 id="problem-title" className="mx-auto mt-3 max-w-3xl text-balance text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-224" data-mp="35gat1ggwid5p">
            ¿Cuántas clases más vas a preparar sobre Automatización Industrial sin tener el material correcto?
          </h2>
          <p className="mx-auto mt-5 max-w-3xl leading-relaxed text-mutedDark" data-id="element-225" data-mp="3eew64w3lszz3">
            Buscás información en internet que no tiene secuencia didáctica ni menciona la realidad de los procesos industriales
            en Argentina. Armás planificaciones desde cero cada ciclo lectivo. Y cuando un alumno pregunta cómo programar una
            secuencia en PLC, qué sensor usar para detectar un objeto, cómo funciona un variador de frecuencia, cómo integrar
            una red Modbus, cómo diseñar un HMI para supervisar un proceso, o qué significa realmente automatizar una máquina en
            una empresa argentina en 2026, no tenés una respuesta que los enganche con la realidad del campo de la automatización
            argentina.
          </p>
          <p className="mt-4 font-bold text-gold" data-id="element-226" data-mp="171mv31b5skig">No es falta de vocación profesional. Es que nadie armó el sistema completo para vos.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="panel-dark mt-9 rounded-md border border-lineDark border-l-2 border-l-gold p-6 sm:p-8" data-id="element-227" data-mp="1bzy6vhl0l53b">
          <p className="mb-5 font-mono text-sm font-bold uppercase tracking-[.14em] text-mutedDark" data-id="element-228" data-mp="ozqx899vhrwl">Esto te está pasando ahora mismo:</p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-229" data-mp="k2qofqln2b1s">
            {problems.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-onDark" data-id="element-230" data-mp="y1qcox58onxf">
                <span className="mt-0.5 shrink-0 rounded-sm bg-violet p-1" data-id="element-231" data-mp="tyagu30zurls">
                  <XIcon className="h-3.5 w-3.5 text-mutedDark" data-id="element-232" data-mp="17yl9nblv6g9l" />
                </span>
                {item}
              </li>)}
          </ul>
        </motion.div>

        <p className="mt-8 text-center font-bold text-gold" data-id="element-233" data-mp="1hoy4bwne7ptg">
          ¿Y si esta fuera la última semana que enseñás Automatización Industrial sin tener todo resuelto?
        </p>

        <p className="mx-auto mt-6 max-w-3xl text-center leading-relaxed text-mutedDark" data-id="element-234" data-mp="1crxxvkmmsl1t">
          Con el MEGAPACK AUTOMATIZACIÓN INDUSTRIAL LISTO, tu próxima clase ya empieza diferente. Tus alumnos no aprenden
          automatización como un conjunto de conceptos abstractos. Aprenden que cada sistema automatizado existe porque alguien
          decidió que la eficiencia, la precisión y la seguridad son fundamentales en la industria moderna.
        </p>
      </div>
    </section>;
}